// services/workPreference.ts
import api from './api';
import { 
  AvailableMember, 
  WorkPreference, 
  PREFERENCE_TYPES 
} from '../types/workPreference';
import { format } from 'date-fns';

export const workPreferenceService = {
  // 未割当メンバー取得
  // async getAvailableMembers(date: Date, departmentType: 'equipment' | 'scaffolding'): Promise<AvailableMember[]> {
  //   try {
  //     // 日付を YYYY-MM-DD 形式にフォーマット
  //     const formattedDate = format(date, 'yyyy-MM-dd');
      
  //     const response = await api.get('/work-preferences/available-members', {
  //       params: {
  //         date: formattedDate,
  //         departmentType
  //       }
  //     });
      
  //     // APIレスポンス形式によって適切に処理
  //     if (response.data && response.data.success) {
  //       return response.data.data || [];
  //     } else if (Array.isArray(response.data)) {
  //       return response.data;
  //     } else {
  //       console.warn('Unexpected response format:', response.data);
  //       return [];
  //     }
  //   } catch (error) {
  //     console.error('Error fetching available members:', error);
  //     return [];
  //   }
  // },


  async getAvailableMembers(date: Date, departmentType: 'equipment' | 'scaffolding'): Promise<AvailableMember[]> {
    try {
      // 日付をYYYY-MM-DD形式にフォーマット（ローカルタイムゾーンで）
      const formattedDate = format(date, 'yyyy-MM-dd');
      
      const response = await api.get('/work-preferences/available-members', {
        params: {
          date: formattedDate,
          departmentType
        }
      });
      
      // レスポンス形式を統一処理
      let result: AvailableMember[] = [];
      
      if (response.data && response.data.success) {
        result = response.data.data || [];
      } else if (Array.isArray(response.data)) {
        result = response.data;
      } else if (response.data && Array.isArray(response.data.members)) {
        // 別の可能性のあるレスポンス形式
        result = response.data.members;
      } else {
        console.warn('Unexpected response format:', response.data);
        result = [];
      }

      return result;
    } catch (error) {
      console.error('Error fetching available members:', error);
      return [];
    }
  },

  // 勤務希望設定
  async setWorkPreference(
    memberId: number, 
    departmentId: number, 
    date: Date, // Date型のまま
    preferenceType: number, 
    memo: string = ''
  ): Promise<boolean> {
    try {
      const response = await api.post('/work-preferences', {
        memberId,
        departmentId,
        date: date, // date自体を渡すのではなく、フォーマットした文字列を渡す
        preferenceType,
        memo
      });
      
      return response.data.success;
    } catch (error) {
      console.error('Error setting work preference:', error);
      return false;
    }
  },

  // 勤務希望削除
  async deleteWorkPreference(
    memberId: number, 
    departmentId: number, 
    date: Date // Date型のまま
  ): Promise<boolean> {
    try {
      const response = await api.delete(`/work-preferences/${memberId}/${departmentId}/${date}`);
      return response.data.success;
    } catch (error) {
      console.error('Error deleting work preference:', error);
      return false;
    }
  },

  // 特定日の勤務希望一覧取得
  async getWorkPreferencesByDate(
    date: string, 
    departmentId?: number
  ): Promise<WorkPreference[]> {
    try {
      const params: { date: string; departmentId?: number } = { date };
      if (departmentId !== undefined) {
        params.departmentId = departmentId;
      }

      const response = await api.get('/work-preferences', { params });
      return response.data.success ? response.data.data : [];
    } catch (error) {
      console.error('Error fetching work preferences by date:', error);
      return [];
    }
  },

  // 勤務希望タイプを文字列表現に変換
  getPreferenceTypeName(preferenceType: number | null | undefined): string {
    if (preferenceType === null || preferenceType === undefined) {
      return '';
    }
    
    switch (preferenceType) {
      case PREFERENCE_TYPES.WANT_OFF:
        return '休みたい';
      case PREFERENCE_TYPES.MUST_WORK:
        return '必ず働きたい';
      case PREFERENCE_TYPES.PREFER_WORK:
        return 'できれば働きたい';
      default:
        return '';
    }
  },

  // 勤務希望タイプに応じた色コードを返す
  getPreferenceTypeColor(preferenceType: number | null | undefined): string {
    if (preferenceType === null || preferenceType === undefined) {
      return '';
    }
    
    switch (preferenceType) {
      case PREFERENCE_TYPES.WANT_OFF:
        return '#f44336'; // 赤系
      case PREFERENCE_TYPES.MUST_WORK:
        return '#4caf50'; // 緑系
      case PREFERENCE_TYPES.PREFER_WORK:
        return '#2196f3'; // 青系
      default:
        return '';
    }
  }
};